module.exports = __webpack_public_path__ + "img/use_epi.26969fc2.svg";